import axios from 'axios';

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from 'components/Loading/Loading';
import { compactDateTime } from '../../../../utils/timeUtils';
import { truncateString } from '../../../../utils/textUtils';

import './style.css';

class BadRatings extends Component {
  constructor(props) {
    super(props);
    this.state = { results: [], loading: false };
  }

  componentDidMount() {
    this.fetchBadRatings();
  }

  fetchBadRatings = async () => {
    this.setState({loading: true});
    await axios
      .get(
        `${process.env.REACT_APP_BACKEND_URL}/admin/appointments/bad-ratings`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.props.user.token}`
          }
        }
      )
      .then(response => {
        console.log(response);
        console.log(response.data);
        this.setState({results: response.data.data, loading: false});
      })
      .catch(() => {
        this.setState({loading: false});
        alert('Problem getting the ratings!');
      });
  }

  render() {
    return (
      <div className="BadRatings">
        <div className="col-auto">
          <div className="row">
            <div className="card">
              {this.state.loading && <Loading />}
              {!this.state.loading && (
                <table className="table table-striped table-sm table-hover borderless">
                  <thead>
                    <tr>
                      <th title="Appointment ID" scope="col">ID</th>
                      <th title="Appointment Date" scope="col">Date</th>
                      <th scope="col">Rating</th>
                      <th scope="col">Feedback</th>
                      <th scope="col">Issue?</th>
                      <th scope="col">Teacher</th>
                      <th scope="col">Student</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.results.map(appointment => (
                      <tr title={appointment.feedback} key={appointment.id}>
                        <td>{appointment.id}</td>
                        <td>{compactDateTime(appointment.startTime)}</td>
                        <td>{appointment.rating}</td>
                        <td>{truncateString(appointment.feedback, 6)}</td>
                        <td>{appointment.issue !== null ? 'Yes' : 'No'}</td>
                        <td>{appointment.teacher.email}</td>
                        <td>{appointment.student.email}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user
  };
}

export default connect(
  mapStateToProps,
  {}
)(BadRatings);



// WEBPACK FOOTER //
// ./src/pages/admin/routes/BadRatings/index.js